// app/page.tsx
import { Thread } from "@/components/assistant-ui/thread";
import { ThreadList } from "@/components/assistant-ui/thread-list";
import { useAui, AuiProvider, Suggestions } from "@assistant-ui/react";
import { ProjectChatGuard } from "./remote-threadlist-adapter";

function ThreadWithSuggestions() {
  const aui = useAui({
    suggestions: Suggestions([
      {
        title: "Start a new topic",
        label: "in this conversation",
        prompt: "Let's discuss something interesting. Suggest a topic!",
      },
      {
        title: "Help me brainstorm",
        label: "some project ideas",
        prompt: "Help me brainstorm ideas for a weekend side project.",
      },
    ]),
  });
  return (
    <AuiProvider value={aui}>
      <Thread />
    </AuiProvider>
  );
}
export default function Page() {

  return (
    <ProjectChatGuard>
      <div className="grid h-dvh grid-cols-[220px_1fr]">
        <ThreadList />
        <ThreadWithSuggestions />
      </div>
    </ProjectChatGuard>
  );
}